import { useEffect, useState } from 'react';

export const useListScroll = (id: string) => {
  const [isListScrolled, setIsListScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const listHeader = document.getElementById(id)!;
      const listHeaderRect = listHeader.getBoundingClientRect();

      if (!listHeaderRect.top) {
        setIsListScrolled(true);
      } else {
        setIsListScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [id]);

  return {
    isListScrolled,
  };
};
